import React from 'react';
import { useField } from 'formik';
import { Check } from 'lucide-react';
import CustomButton from '../../../components/common/CustomButton/CustomButton';

const InputWithActionButton = ({
    name,
    label,
    placeholder,
    buttonLabel,
    onClick,
    verified,
    required,
    disabled = false,
    loading = false,
    helperText: customHelperText,
    ...props
}) => {
    const [field, meta] = useField(name);
    const { touched, error } = meta;

    const showError = touched && error;
    const helperText = showError ? error : customHelperText;

    return (
        <div className="w-full">
            <label className="block text-sm font-medium mb-1" htmlFor={name}>
                {label} {required && <span className="text-red-500">*</span>}
            </label>

            <div
                className={`flex items-center border rounded-md overflow-hidden focus-within:ring-1 ${showError
                        ? 'border-red-600 focus-within:ring-red-600'
                        : 'focus-within:ring-gray-500'
                    }`}
            >
                <input
                    {...field}
                    {...props}
                    id={name}
                    disabled={disabled || loading}
                    placeholder={placeholder}
                    className="flex-1 px-3 py-3 outline-none text-sm text-black placeholder:text-gray-400"
                    aria-describedby={`${name}-helper-text`}
                    aria-invalid={showError}
                />
                {buttonLabel && (
                    <CustomButton
                        label={buttonLabel}
                        onClick={() => onClick && onClick(field.value)}
                        type="button"
                        isLoading={loading}
                        disabled={disabled || loading}
                        variant="default"
                        size="sm"
                        className="rounded-none border-l border-gray-300 !px-4 !py-2"
                        labelClassName="text-sm"
                    />
                )}
            </div>

            {(helperText || verified) && (
                <div
                    id={`${name}-helper-text`}
                    className={`mt-1 text-xs flex gap-1 font-semibold ${showError ? 'justify-start' : 'justify-end'
                        } ${showError ? 'text-red-500' : 'text-blue-600'}`}
                    role="alert"
                    aria-live="polite"
                >
                    {!showError && verified && (
                        <Check size={14} className="text-green-600 mt-0.5" />
                    )}
                    {helperText && <span>{helperText}</span>}
                </div>
            )}
        </div>
    );
};

export default InputWithActionButton;